
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue1 as ObiWindTrue1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-1.js';
 
 
 

 
 export const ObiWindTrue1 = createComponent({
   react: React,
   tagName: 'obi-wind-true-1',
   elementClass: ObiWindTrue1Element,
   events: {
     
   }
  });
 
 